import { Parser } from "@quest/platform-murka-phase_2/dist";
import { gameConstants } from "../Constants/gameConstants";
import { PlatformConstantsGame } from "../Constants/PlatformConstantsGame";
import { clone, dispatcher, IEvent, ingenuity, IObject } from "@quest/base-core";
import { GameParserModel } from "./GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { ILines, IParamsData } from "@quest/oddsworks-platform";
import { SlotConstants } from "@quest/slot-core";
import { EventConstants as PlatformEventConstants } from "@quest/platform-core";

export class GameParser extends Parser {
  protected model: GameParserModel;
  protected specialSymNum: number[] = [66, 200, 300, 152, 151];
  protected udpatedSpecialSymNum: number[] = [10, 8, 9, 13, 13];
  protected mysterySymols = [77]; // mystery symbol id
  protected mysterySymbol = 2; //initially
  protected wildMultiID = [0, 17, 18, 19, 20];

  protected bindEvent(): void {
    super.bindEvent();
    dispatcher.on(eventDispatchers.PARSE_NEXT_CASCADE_DATA, this.parseNextCascadeData, this);
    dispatcher.on(eventDispatchers.PARSE_NEXT_HOLD_AND_RESPIN_DATA, this.parseNextHoldAndRespinData, this);
  }
  // Override to update win lines offset position based on 8X5 grid
  protected processLinesData(data: ILines[]): void {
    super.processLinesData(data);
    this.model.setWinLinesData(this.updateWinLineOffSet(this.model.getWinLinesData()));
    this.model.setCascadeLineToggleCount(this.model.getWinLinesData().length);
    this.checkBoundarySymbols(data);
  }
  // To find bountry symbols
  private checkBoundarySymbols(data: ILines[]): void {
    let linesData: IObject[] = [];
    data.forEach((value: any, index: number) => {
      let lines: IObject[] = [];
      lines.push(value);
      let eachLine: IObject[] = [];
      const uniqueOffsets = [...new Set(lines.flatMap((entry) => entry.matchPositions))].map((pos) => pos - 1);
      uniqueOffsets.forEach((val) => {
        let boundDetails: any = {};
        boundDetails = {
          top: this.getTopBound(uniqueOffsets, val),
          bottom: this.getBottomBound(uniqueOffsets, val),
          left: this.getLeftBound(uniqueOffsets, val),
          right: this.getRightBound(uniqueOffsets, val),
          pos: val,
        };
        eachLine.push(boundDetails);
      });
      linesData[index] = clone(eachLine);
    }, this);
    this.model.setWinSymBounds(linesData);
  }
  // To get symbols as a top symbols for cluster win
  private getTopBound(uniqueOffsets: number[], val: number): boolean {
    if (Math.floor(val / this.model.getNumCols()) == 0) {
      return true;
    } else if (val - this.model.getNumCols() >= 0 && !uniqueOffsets.includes(val - this.model.getNumCols())) {
      return true;
    } else {
      return false;
    }
  }
  // To get symbols as a bottom symbols for cluster win
  private getBottomBound(uniqueOffsets: number[], val: number): boolean {
    if (Math.floor(val / this.model.getNumCols()) == this.model.getNumRows() - 1) {
      return true;
    } else if (!uniqueOffsets.includes(val + this.model.getNumCols())) {
      return true;
    } else {
      return false;
    }
  }
  // To get symbols as a left symbols for cluster win
  private getLeftBound(uniqueOffsets: number[], val: number): boolean {
    if (val % this.model.getNumCols() == 0) {
      return true;
    } else if (!uniqueOffsets.includes(val - 1)) {
      return true;
    } else {
      return false;
    }
  }
  // To get symbols as a right symbols for cluster win
  private getRightBound(uniqueOffsets: number[], val: number): boolean {
    if (val % this.model.getNumCols() == this.model.getNumCols() - 1) {
      return true;
    } else if (!uniqueOffsets.includes(val + 1)) {
      return true;
    } else {
      return false;
    }
  }
  /** Update win line offset */
  private updateWinLineOffSet(winnings: any): any {
    for (let i: number = 0; i < winnings.length; i++) {
      const winOffset: any = winnings[i];
      for (let j: number = 0; j < winOffset.positions.length; j++) {
        winnings[i].positions[j][1] = winnings[i].positions[j][1] + gameConstants.OFFSET_INCREMENT_X5;
      }
    }
    return winnings;
  }
  /**
   * to store initial reelGrid
   */
  protected processReelsData(reelsData: any): void {
    this.model.setInitialBaseReel(clone(reelsData[PlatformConstantsGame.BASE_GAME_REELSET]));
    this.model.setInitialFreeReel(clone(reelsData[PlatformConstantsGame.FREE_GAME_REELSET]));
    this.model.setBaseReel(this.changeSymbolNumber(reelsData[PlatformConstantsGame.BASE_GAME_REELSET]));
    this.model.setFreeSpinReel(this.changeSymbolNumber(reelsData[PlatformConstantsGame.FREE_GAME_REELSET]));
  }
  /**to add game flow and eleiminate multiple calls */
  protected processGameParameters(params: any): void {
    this.model.setTotalBet(params.betPerLineDefault * params.betDivisor);
    this.model.setCurrentTotalBet(params.betPerLineDefault * params.betDivisor);
    this.model.setArrayNumChips(params.betPerLine);
    this.model.setMinBet(params.betPerLine[0]);
    this.model.setMaxBet(params.betPerLine[params.betPerLine.length - 1]);
    this.model.setCurrentBetIndex(params.betPerLine.indexOf(this.model.getBetPerLineDefault()));
    this.model.setAutoPlayDefault(params.autoPlayDefault);
    this.model.setAutoPlayList(params.autoPlayList);
    this.model.setBetDivisor(params.betDivisor);
    this.model.setBetPerLine(params.betPerLine);
    this.model.setBetPerLineDefault(params.betPerLineDefault);
    this.model.setNoPrizeReelLayout(params.noPrizeReelLayout);
    this.processPaytableData(params.payTable);
    this.processReelsData(params.reels);
    this.storeWinLineValues(gameConstants.lineLayout);
    this.model.setLinesPlayed(params.betDivisor);
    this.model.setCurrentBet(this.model.getBetPerLineDefault());
    this.model.setCurrentBetIndex(this.model.getBetPerLine().indexOf(this.model.getCurrentBet()));
    this.model.setReelGrid(this.updateReelGrid(this.model.getNoPrizeReelLayout()));
    this.storeCollectionFishesData(params);
    if (params?.responseHistory) {
      this.checkAndStoreBrokenData(params.responseHistory);
    }
    if (!ingenuity.configData.isBrokenGame) {
      this.model.setReelGrid(this.convertReelGrid(this.model.getReelGrid()));
      this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
    }
  }
  /**
   * to store data related to collection journey panel
   */
  private storeCollectionFishesData(params: any) {
    params.HoldNRespinBoxMultipliers && this.model.setHoldNRespinBoxMultipliers(params.HoldNRespinBoxMultipliers);
    this.model.setCollectionMeter151(params.CollectionMeter151);
    this.model.setCollectionMeter152(params.CollectionMeter152);
    params.CollectionMeter151BoxMultipliers &&
      this.model.setCollectionMeter151BoxMultiplier(params.CollectionMeter151BoxMultipliers);
    params.CollectionMeter152BoxMultipliers &&
      this.model.setCollectionMeter152BoxMultiplier(params.CollectionMeter152BoxMultipliers);
    this.model.setCollectionMeter151MaxLimits(params.CollectionMeter151MaxLimits);
    this.model.setCollectionMeter152MaxLimits(params.CollectionMeter152MaxLimits);
  }

  /**
   * Convert 3x5 reel grid into 8x5 using reel set
   * only for init
   */
  private convertReelGrid(reelGrid: number[][]): number[][] {
    const reelSetLengthDecrement: number = 5;
    if (reelGrid) {
      const finalGrid: number[][] = [];
      for (let i: number = 0; i < reelGrid.length; i++) {
        let reelSet: number[] = clone(this.model.getBaseReel()[i]);
        let indx: number;
        for (let index: number = 0; index < reelSet.length - reelSetLengthDecrement; index++) {
          if (
            reelSet[index] === reelGrid[i][0] &&
            reelSet[index + 1] === reelGrid[i][1] &&
            reelSet[index + 2] === reelGrid[i][2] &&
            reelSet[index + 3] === reelGrid[i][3] &&
            reelSet[index + 4] === reelGrid[i][4]
          ) {
            indx = index;
            break;
          }
        }
        finalGrid.push(this.storeValueInReelGrid(reelGrid[i], indx, reelSet));
      }
      return finalGrid;
    }
  }
  /**
   * Add to update reel grid with stack
   */
  private updateReelGridWithStack(grid: any): any {
    let stackData: number[][] = gameConstants.MAN_AND_LADY_STACK_DATA;
    stackData.forEach((value: number[]) => {
      let stackId: number = value[0];
      let stackSize: number = value[1];
      let stackReplaceId: number = value[2];
      for (let j: number = 0; j < grid.length; j++) {
        let count: number = 0;
        for (let i: number = grid[j].length - 1; i >= 0; i--) {
          if (grid[j][i] === stackId) {
            count++;
          } else {
            count = 0;
          }
          if (count === stackSize) {
            grid[j][i] = stackReplaceId;
            for (let k = 1; k < value[1]; k++) {
              grid[j][i + k] = gameConstants.TRANSPARENT_SYMBOL_ID;
            }
            count = 0;
          }
        }
        const lastIndex: number = grid[j].length;
        if (grid[j][lastIndex - 1] === stackId) {
          for (let m = grid[j].length - 1; m >= grid[j].length - stackSize; m--) {
            if (grid[j][m] !== stackId) {
              grid[j][m + 1] && (grid[j][m + 1] = stackReplaceId);
              for (let k = 2; k < stackSize; k++) {
                grid[j][m + k] && (grid[j][m + k] = gameConstants.TRANSPARENT_SYMBOL_ID);
              }
              break;
            }
          }
        }
      }
    }, this);
    return grid;
  }
  /**to parse feature specific data */
  protected processBonusInfo(response?: any[]): void {
    super.processBonusInfo(response);
    response.length &&
      response.forEach((data) => {
        if (data.bonusName === ingenuity.configData.Cascading) {
          this.processCascadeData(data);
        } else if (data.bonusName === ingenuity.configData.IconSymbolsReplacement) {
          this.parseSymbolReplacementData(data);
        } else if (data.bonusName === ingenuity.configData.Initialize) {
          this.model.setCollectionMeter151(data.preMeterdetails151);
          this.model.setCollectionMeter152(data.preMeterdetails152);
        } else if (data.bonusName === ingenuity.configData.Baits) {
          this.parseBaitDataAndSymbolInInitialGrid(data);
        } else if (data.bonusName === ingenuity.configData.CollectionPayout) {
          this.parseCollectionPayoutData(data);
        } else if (data.bonusName === ingenuity.configData.WildSymbols) {
          this.model.setWildData(data);
        } else if (data.bonusName === ingenuity.configData.HoldAndReSpinCheck) {
          this.parseHoldAndRespinData(data);
        } else if (data.bonusName === ingenuity.configData.HnRLayout) {
          this.parseHoldAndRespinLayout(data);
        } else if (data.bonusName === ingenuity.configData.HnRMovingFishFunctionality) {
          this.parseHoldAndRespinMovingFishFunctionality(data);
        }
      });
  }
  /**
   *
   * @param response update symbol's ID in reellayout
   */
  private parseSymbolReplacementData(response: any): void {
    this.mysterySymbol = response.icon77Replacement;
    if (response.icon66Positions.length != 0) {
      this.setRevealData(response);
    }
    response.icon66Replacement === 77 && this.model.setRevealSymNum(this.mysterySymbol);
    if (this.specialSymNum.includes(this.mysterySymbol)) {
      this.mysterySymbol = this.udpatedSpecialSymNum[this.specialSymNum.indexOf(this.mysterySymbol)];
    }
    this.model.setInitialSpinningGrid(response.initialReelLayout);
    this.updateReelSetAsPerReplacedSymbols();
  }
  /**
   * update the symbols from reel set as per the updated reveal symbol and mystry symbol positions
   */
  private updateReelSetAsPerReplacedSymbols(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      this.model.setFreeSpinReel(this.changeSymbolNumber(clone(this.model.getInitialFreeReel())));
      dispatcher.fireEvent(eventDispatchers.UDPATE_NEW_FG_REELSET);
    } else {
      this.model.setBaseReel(this.changeSymbolNumber(clone(this.model.getInitialBaseReel())));
      dispatcher.fireEvent(eventDispatchers.UDPATE_NEW_REELSET);
    }
    if (this.model.getFreeGameBroken()) {
      this.model.setFreeSpinReel(this.changeSymbolNumber(clone(this.model.getInitialFreeReel())));
      dispatcher.fireEvent(eventDispatchers.UDPATE_NEW_FG_REELSET);
    }
  }
  // function will add the respin trigger symbols at the positions of random baits
  private parseBaitDataAndSymbolInInitialGrid(data: any): void {
    this.resetBaitData();
    this.model.setBaitData(data);
    this.model.setTriggeredBait(data.baitSymbol);
    this.model.setIsBaitPresent(true);
    this.model.setBaitCount(data.totalBaitsPut);
    const baitSymOffsets: number[] = data.baitPositions;
    const common: number[] = data.baitPositions.filter((item: number) =>
      new Set(this.model.getRevealSymPositions()).has(item)
    );
    if (common.length > 0) {
      this.model.setChestRevealPositions(common); // <-- You may need to implement this method in your model
    }
    this.model.setBaitSymOffsets(this.getGridToOffset(baitSymOffsets));
    if (data.baitPositions.length === data.totalBaitsPut) {
      let stoppingGrid = clone(this.model.getInitialSpinningGrid());
      data.baitPositions.forEach((pos: number) => {
        if (!common.includes(pos)) {
          stoppingGrid[pos - 1] = gameConstants.RESPIN_TRIGGER_SYM;
        }
      });
      this.model.setInitialSpinningGrid(stoppingGrid);
    }
  }
  /**
   * to reset bait related data
   */
  private resetBaitData(): void {
    this.model.setIsBaitPresent(false);
    this.model.setBaitCount(0);
    this.model.setBaitData("");
    this.model.setBaitSymOffsets([]);
    this.model.setChestRevealPositions([]);
  }
  /**
   * to parse collection payout data
   */
  private parseCollectionPayoutData(data: any): void {
    this.resetCollectionPayoutData();
    this.model.setCollectionCreditsWon(data.creditsWon);
    this.model.setCollectionPayoutData(data);
    this.model.setCollectionMeterData151(data.collectionMeterData151);
    this.model.setCollectionMeterData152(data.collectionMeterData152);
    this.model.setMetersAwarded151(data.metersAwarded151);
    this.model.setMetersAwarded152(data.metersAwarded152);
  }
  /**
   * to reset collection payout data  
   */
  private resetCollectionPayoutData(): void {
    this.model.setCollectionCreditsWon(0);
    this.model.setCollectionPayoutData({});
    this.model.setCollectionMeterData151([]);
    this.model.setCollectionMeterData152([]);
  }

  /**
   * overrided to avoid multiple calls flow
   */
  protected processParameters(params: IParamsData): void {
    this.resetHoldAndRespinData();
    this.model.setBaseGameTotalWin(0);
    let updatedData: any = this.parseCascadeDataInSpinResponse(params);
    this.model.setCreditsWon(updatedData.creditsWon);
    this.model.setFreePlaysData(updatedData.free_plays_data);
    this.resetRevealData();
    this.resetBaitData();
    this.model.setGameVersion(updatedData.gameVersion);
    this.model.setJackpotsInfo(updatedData.jackpotsInfo); //Need to confirm its data
    this.model.setReelLayout(updatedData.reelLayout);
    this.model.setReelStops(updatedData.reelStops);
    this.processWinningLines(updatedData.winningLines);
    this.processBonusInfo(updatedData.bonusInfo);
    const creditsWon = this.model.getCreditsWon();
    this.model.setCurrentWin(creditsWon);
    this.model.setTotalWin(creditsWon);
    this.model.setCurrentSpinTotalWinAmt(updatedData.creditsWon);
    this.model.setBaseGameTotalWin(this.model.getCascadeTotalWin());
    creditsWon > 0 ? this.model.setHasWin(true) : this.model.setHasWin(false);
    this.parseFreeSpinSymbolOffsets();
    this.processTriggerScatterWin(updatedData);
    this.checkForStackSymInReelGrid();
    this.model.setGameWinAmt(this.model.getBaseGameWinAmt());
    this.model.setBaseGameStops(params.reelStops);
    const grid = this.updateReelGrid(this.model.getInitialSpinningGrid());
    this.model.setReelGrid(
      this.convertReelGridWithStops(grid, this.model.getBaseGameStops(), this.model.getBaseReel())
    );
    this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
    if (ingenuity.configData.isBrokenGame) {
      this.model.setTriggerReelGrid(this.model.getReelGrid());
      this.model.setLastCascadeGridForFg(this.getTriggeringGrid(params));
    }
  }
  /**
   * function will parse the last cascasde grid to handle the basegame returining grid in case of freegame broken
   */
  private getTriggeringGrid(data: any): number[][] {
    let grid: number[]
    data.bonusInfo.forEach((info: any) => {
      if (info.bonusName === "Cascading") {
        if (info?.cascadeList?.length) {
          grid = info.cascadeList[info.cascadeList.length - 1]?.cascadeGrid
        }
      }
    })
    let updatesGrid
    if (grid?.length) {
      updatesGrid = this.updateReelGrid(grid)
      updatesGrid = this.updateReelGridWithStack(this.convertReelGridWithStops(updatesGrid, this.model.getBaseGameStops(), this.model.getBaseReel()))
    }
    return updatesGrid?.length > 0 ? updatesGrid : [];

  }
  // Override to parse freespin triggered
  protected parseFreeSpin(response: any): void {
    super.parseFreeSpin(response);
    this.model.setIsFreeSpintriggered(true);
  }
  /**
   * to handle cascade
   */
  protected parseNextFreeSpinData(evt: IEvent): void {
    const response = this.model.getFreeGameResponse();
    const data = response[this.model.getCurrentFreeSpinCount()][0];
    let updatedData: any = this.parseCascadeDataInSpinResponse(data);
    this.resetRevealData();
    this.model.getTriggerWinLinesData().length = 0;
    this.model.getTriggerScatterWinData().length = 0;
    this.model.getFreeSpinsRemaining()
      ? this.model.setFreeSpinsRemaining(this.model.getFreeSpinsRemaining() - 1)
      : this.model.setFreeSpinsRemaining(0);
    updatedData.spinsRetrigger && this.model.setRetriggerFreeSpins(updatedData.spinsRetrigger);
    this.model.setFreeSpinWinAmt(this.model.getFreeSpinWinAmt() + updatedData.creditsWon);
    this.model.setCurrentWin(updatedData.creditsWon);
    updatedData.creditsWon > 0 ? this.model.setHasWin(true) : this.model.setHasWin(false);
    this.processLinesData(updatedData.winningLines.lines);
    this.model.getWinLinesData().length > 0 ? this.model.setHasLineWins(true) : this.model.setHasLineWins(false);
    this.model.getTriggerScatterWinData().length > 0 && this.model.setHasScatterWins(true);
    this.model.setCurrentFreeSpinCount(this.model.getCurrentFreeSpinCount() + 1);
    this.processBonusInfo(updatedData.bonusInfo); // to check reetrigger
    this.model.setFreeGameStops(updatedData.reelStops);
    this.model.setReelGrid(this.updateReelGrid(this.model.getInitialSpinningGrid()));
    if (Object.keys(this.model.getWildData().wildPositionMultiplier).length != 0) {
      this.model.setReelGrid(this.parseWildSymbolData(this.model.getWildData()));
    }
    this.model.setReelGrid(
      this.convertReelGridWithStops(
        this.model.getReelGrid(),
        this.model.getFreeGameStops(),
        this.model.getFreeSpinReel()
      )
    );
    this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
    dispatcher.fireEvent(PlatformEventConstants.SPIN_RESPONSE_PROCESSED);
    this.checForStackSyminReelGridFG();
  }
  /**
   * to handle cascade
   */
  protected parseBrokenFreeGameData(): void {
    this.model.getTriggerWinLinesData().length = 0;
    this.model.getTriggerScatterWinData().length = 0;
    const data = this.model.getFreeGameResponse()[this.model.getCurrentFreeSpinCount()][0];
    let updatedData: any = this.parseCascadeDataInSpinResponse(data);
    updatedData.creditsWon > 0 ? this.model.setHasWin(true) : this.model.setHasWin(false);
    this.model.setCurrentWin(updatedData.creditsWon);
    this.model.setFreeSpinWinAmt(updatedData.creditsWonAccumulated + updatedData.creditsWon);
    this.model.setFreeSpinAccumulatedWinAmt(updatedData.creditsWonAccumulated);
    this.processLinesData(updatedData.winningLines.lines);
    this.model.getTriggerScatterWinData().length > 0 && this.model.setHasScatterWins(true);
    this.processBonusInfo(updatedData.bonusInfo);
    this.model.setCurrentFreeSpinCount(this.model.getCurrentFreeSpinCount() + 1);
    this.model.setFreeGameStops(updatedData.reelStops);

    this.model.setReelGrid(this.updateReelGrid(this.model.getInitialSpinningGrid()));
    if (Object.keys(this.model.getWildData().wildPositionMultiplier).length != 0) {
      this.model.setReelGrid(this.parseWildSymbolData(this.model.getWildData()));
    }

    this.model.setReelGrid(
      this.convertReelGridWithStops(
        this.model.getReelGrid(),
        this.model.getFreeGameStops(),
        this.model.getFreeSpinReel()
      )
    );
    this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
    if (ingenuity.configData.isBrokenGame) {
      this.model.setTriggerReelGrid(this.model.getLastCascadeGridForFg());
    }
  }
  /**
   * function will change first cascade grid with actual response reel grid
   */
  private parseCascadeDataInSpinResponse(response: any): any {
    this.resetCascadeData();
    const bonusData = response.bonusInfo.find((data: IObject) => data.bonusName === ingenuity.configData.Cascading);
    if (bonusData?.cascadeList?.length) {
      const cascade = bonusData.cascadeList[0];
      response.reelLayout = cascade.initialGrid;
      response.winningLines = cascade.winningLines;
      response.reelStops = cascade.stops; //will change
      this.model.setTotalCascadeWin(bonusData.creditsWon);
      cascade.cascadeGrid && this.model.setRevealedGrid(cascade.cascadeGrid);
      this.model.setCascadeAccumulatedWin(bonusData.cascadeList[0].winningLines.creditsWon);
    }
    return response;
  }
  /**
   * to parse initial cascasde data
   */
  private processCascadeData(data: any): void {
    this.processWinningLines(data.cascadeList[0].winningLines);
    this.model.setCascadingStatus(true);
    this.model.setCascadeTotalWin(data.creditsWon);
    this.model.setCascadeResponse(data.cascadeList);
    this.model.setCascadingCount(data.cascadeList.length - 1);
  }
  /**
   * parse wild symbol multipliers data
   */
  private parseWildSymbolData(data: any, reelGrid?: number): number[][] {
    this.model.setWildGrid([]);
    const updatedGrid: number[][] = this.model.getReelGrid();
    const wildPositions: number[] = [];
    for (const key in data.wildPositionMultiplier) {
      wildPositions.push(Number(key));
    }
    const wildSymOffsets = this.getGridToOffset(wildPositions);
    wildSymOffsets.forEach(([reel, row], index) => {
      const pos = wildPositions[index];
      const multiplier = this.wildMultiID[data.wildPositionMultiplier[pos] - 1];
      row = updatedGrid[0].length === 5 ? row : row + 5;
      if (updatedGrid[reel] && updatedGrid[reel][row] !== undefined) {
        updatedGrid[reel][row] = multiplier;
      }
    });
    return updatedGrid;
  }
  /**
   * parse Reveal  symbol data
   */
  private setRevealData(data: any): void {
    this.resetRevealData();
    const revealSymPosition: number[] = data.icon66Positions;
    this.model.setRevealSymPositions(revealSymPosition);
    if (data.icon66Replacement != 200 && data.icon66Replacement != 300) {
      this.model.setRevealSymNum(data.icon66Replacement);
    } else {
      this.model.setRevealSymNum(this.udpatedSpecialSymNum[this.specialSymNum.indexOf(data.icon66Replacement)]);
    }
    this.model.setRevealSymOffsets(this.getGridToOffset(revealSymPosition));
    ingenuity.configData.isRevealPresent = true;
    this.model.setRevealAvailable(true);
    if (data.icon66Replacement === 77) {
      this.model.setRevealSymNum(this.mysterySymbol);
    }
  }
  /**
   * reset reveal symbold data
   */
  private resetRevealData(): void {
    this.model.setRevealSymOffsets([]);
    this.model.setRevealSymPositions([]);
    ingenuity.configData.isRevealPresent = false;
    this.model.setRevealAvailable(false);
  }

  /**
   * function will parse next cascade data
   * called after every cascade
   */
  private parseNextCascadeData(): void {
    const index: number = this.model.getCascadeResponse().length - this.model.getCascadingCount();
    this.model.setCascadeNumber(index); // setting current cascade index for FS-BAR
    let currentCascade: any = this.model.getCascadeResponse()[index];
    this.resetRevealData();
    if (currentCascade.icon66Positions.length != 0) {
      this.setRevealData(currentCascade);
    }
    this.model.setCascadeWin(currentCascade.winningLines.creditsWon);
    this.model.setTotalWin(this.model.getTotalWin() + currentCascade.winningLines.creditsWon);
    this.model.setCascadeAccumulatedWin(this.model.getCascadeAccumulatedWin() + currentCascade.winningLines.creditsWon);
    this.model.setCascadeOffsets([this.model.getLinesWinAllUniquePositions()]);
    this.processWinningLines(currentCascade.winningLines);
    this.model.setCurrentCascadingReelNumber(this.getTotalReelBurstOffsets());
    currentCascade.cascadeGrid && this.model.setRevealedGrid(currentCascade.cascadeGrid);

    let bigGrid: number[][];
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      this.model.setBaseGameStops(currentCascade.stops);
      bigGrid = this.convertReelGridWithStops(
        this.updateReelGrid(currentCascade.initialGrid),
        this.model.getBaseGameStops(),
        this.model.getBaseReel()
      );
    } else {
      this.model.setFreeGameStops(currentCascade.stops);
      bigGrid = this.convertReelGridWithStops(
        this.updateReelGrid(currentCascade.initialGrid),
        this.model.getFreeGameStops(),
        this.model.getFreeSpinReel()
      );
    }
    this.model.setGameGridForStack(clone(this.model.getReelGrid()));
    const updatedStackGrid: number[][] = this.updateReelGridWithStack(bigGrid);
    this.model.setReelGrid(updatedStackGrid);
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      if (currentCascade.wildPositionMultiplier && Object.keys(currentCascade.wildPositionMultiplier).length != 0) {
        this.model.setReelGrid(this.parseWildSymbolData(currentCascade));
      }
    }
    dispatcher.fireEvent(eventDispatchers.ON_CASCADE_REELS);
  }

  /**
   * store total reels on which cascade will occur
   */
  private getTotalReelBurstOffsets(): number {
    let totalNumber: number = 0;
    for (let i: number = 0; i < ingenuity.configData.numberOfReel; i++) {
      const cascadeOffsets: number[][][] = this.model.getCascadeOffsets();
      const currentReelBurstOffsets: any = cascadeOffsets[0].filter((item: any) => item[0] === i);
      totalNumber += currentReelBurstOffsets.length ? 1 : 0;
    }
    return totalNumber;
  }

  /**
   * function will add more symbols on reel to make it 6x5 with the help of stops
   */
  private convertReelGridWithStops(grid: number[][], stops: number[], reelSet: number[][]): number[][] {
    let newGrid: number[][] = [];
    stops.forEach((pos: number, index: number) => {
      newGrid[index] = this.storeValueInReelGrid(grid[index], pos, reelSet[index]);
    });
    return newGrid;
  }
  /**
   * Store value in reel grid using reel set
   */
  private storeValueInReelGrid(reelGrid: number[], subsetIndex: number, reelSet: number[]): number[] {
    let reelSetIndex: number = reelSet.length;
    for (let i: number = 0; i < gameConstants.OFFSET_INCREMENT_X5; i++) {
      if (subsetIndex > 0) {
        reelGrid.unshift(reelSet[--subsetIndex]);
      } else {
        reelGrid.unshift(reelSet[--reelSetIndex]);
      }
    }
    return reelGrid;
  }

  /**
   * This method will reset cascade data.
   */
  private resetCascadeData(): void {
    this.model.setCascadingStatus(false);
    this.model.setTotalCascadeWin(0);
    this.model.setCascadeAccumulatedWin(0);
    this.model.setInitialSpinningGrid([]);
    this.model.setRevealedGrid([]);
    this.model.setCascadeNumber(0);
    this.model.setCascadingCount(0);
  }
  /**
   * to update retrigger counter
   */
  protected processRetriggerData(response: any): void {
    this.model.setIsFreeSpinRetriggered(true);
    this.model.setRetriggerFreeSpins(response.extraSpins);
    response.bonusPositions && this.model.setRetriggerOffSet(this.getGridToOffset(response.bonusPositions));
    if (!this.model.getFreeGameBroken()) {
      this.model.setFreeSpinsRemaining(this.model.getFreeSpinsRemaining() + response.extraSpins);
      this.model.setFreeSpinNum(this.model.getFreeSpinNum() + this.model.getRetriggerFreeSpins());
    }
  }

  //hold and respin related parsing
  private parseHoldAndRespinData(data: any): void {
    this.model.setFishingTimeTotalWin(data.creditsWon);
    this.model.setFishingTimeSpinCounter(data.count); // to handle respin counter
    this.model.setCurrentReSpinIndex(0);
    this.model.setFishingTimeSpinsData(data.freeSpinList);
    data.freeSpinList.length && this.model.setFishingTimeTotalCount(data.freeSpinList.length);
    data.freeSpinList.length && this.model.setIsHoldAndRespinAvailable(true);
  }
  /**
   * parse next hold and respin spins data
   */
  private parseNextHoldAndRespinData(): void {
    this.model.setPreviousAwarededBigFishes(this.model.getAwardedBigFishes());
    this.resetHoldAndRespinSpinData();
    // putted commented in case need to run hold and respin quickly to last spin
    // this.model.setCurrentReSpinIndex(this.model.getFishingTimeSpinsData().length - 1)
    let CurrentSpinData = this.model.getFishingTimeSpinsData()[this.model.getCurrentReSpinIndex()][0];
    this.model.setReelGridAfterMovingSymbol(CurrentSpinData.reelLayout);
    this.processBonusInfo(CurrentSpinData.bonusInfo);
    this.storeAutoBaitMovingPosition();
  }
  /**
   * parse data for reel layout inside hold and respin
   */
  private parseHoldAndRespinLayout(data: any): void {
    this.model.setCurrentSpinFishPosition(data.currentSpinFishPosition);
    this.model.setIsSpinsReset(data.spinsReset); // to handle respin counter
    this.model.setTotalLandedFish(data.totalFishes);
    this.model.setIsJackpotAvailable(data.jackpot);
    this.model.setJackpotAmt(data.creditsWon);
  }
  /**
   * parse data related to moving fishes
   */
  private parseHoldAndRespinMovingFishFunctionality(data: any): void {
    this.model.setIsBigFishAwarded(data.awarded);
    this.model.setHnRStoppingReelGrid(data.initialReelLayout);
    this.model.setHnRAccumulatedAmount(data.creditsWonAccumulated);
    this.model.setBigFishData(data.boxSizes);
    this.model.setBigFishWinAmount(data.creditsWon);
    this.model.setAwardedBigFishes(data.allBoxes);
    this.model.getPreviousAwarededBigFishes()?.length && this.model.setRemovedBigFish(this.findNoLongerPresent(this.model.getPreviousAwarededBigFishes(), this.model.getAwardedBigFishes()))
  }
  /**
   * funstion will find the data for big fish which is no longer present s that we can remove it from reel
   */
  private findNoLongerPresent(previous: any, current: any): void {
    let removedObj: any = []
    previous.forEach((data: any) => {
      let elementFound = false
      current.forEach((currentData: any) => {
        if (data.size === currentData.size &&
          data.start_col === currentData.start_col &&
          data.start_row === currentData.start_row &&
          data.dimensions[0] === currentData.dimensions[0] &&
          data.dimensions[1] === currentData.dimensions[1]
        ) {
          elementFound = true
        }
      })
      !elementFound && removedObj.push(data);
    })
    return removedObj
  }
  /**
   * store position of auto bait in the form of [start pos , end pos]
   */
  private storeAutoBaitMovingPosition(): void {
    const initialBaitPos = this.returnSortedBaitPositions(this.model.getHnRStoppingReelGrid());
    const finalBaitPos = this.returnSortedBaitPositions(this.model.getReelGridAfterMovingSymbol());
    let movingPositionArray: number[][] = [];
    const uniqueInitial = initialBaitPos.filter((pos) => !finalBaitPos.includes(pos));
    const uniqueFinal = finalBaitPos.filter((pos) => !initialBaitPos.includes(pos));
    for (let i = 0; i < Math.min(uniqueInitial.length, uniqueFinal.length); i++) {
      movingPositionArray.push([uniqueInitial[i], uniqueFinal[i]]);
    }
    this.model.setPositionBaitPosition(movingPositionArray);
  }
  /**
   * function will return the
   */
  private returnSortedBaitPositions(arr: any): number[] {
    return arr
      .map((val: number | null, index: number) => (val === 150 ? index : -1))
      .filter((index: number) => index !== -1)
      .sort((pos1: number, pos2: number) => pos1 - pos2);
  }
  /**
   * to reset feature data on next basegame spin
   */
  private resetHoldAndRespinData(): void {
    this.model.setFishingTimeTotalWin(0);
    this.model.setFishingTimeTotalCount(0);
    this.model.setFishingTimeSpinCounter(0);
    this.model.setCurrentReSpinIndex(0);
    this.model.setFishingTimeSpinsData(null);
    this.model.setReelGridAfterMovingSymbol([]);
    this.model.setIsHoldAndRespinAvailable(false);
    this.model.setPreviousAwarededBigFishes([]);
    this.model.setRemovedBigFish([]);
  }
  /**
   * reset hold and respin spinning time data
   */
  private resetHoldAndRespinSpinData(): void {
    this.model.setCurrentSpinFishPosition([]);
    this.model.setIsSpinsReset(false);
    this.model.setTotalLandedFish(0);
    this.model.setPositionBaitPosition([]);
    this.model.setIsBigFishAwarded(false);
    this.model.setHnRStoppingReelGrid([]);
    this.model.setHnRAccumulatedAmount(0);
    this.model.setBigFishData([]);
    this.model.setReelGridAfterMovingSymbol([]);
    this.model.setAwardedBigFishes({});
    this.model.setRemovedBigFish([]);
  }
  protected processGameAfterError(): void {
    super.processGameAfterError();
    this.model.setReelGrid(this.convertReelGrid(this.model.getReelGrid()));
    this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
  }
}
